import { render } from "./PlaySvg.vue?vue&type=template&id=010d3316"
import script from "./PlaySvg.vue?vue&type=script&lang=js"
export * from "./PlaySvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__